import React from 'react';
import './Footer.css';

const Footer = () => {
  // Current year for copyright
  const currentYear = new Date().getFullYear();
  
  // Social media links
  const socialLinks = [
    { name: 'Facebook', icon: 'facebook.svg', url: 'https://facebook.com'},
    { name: 'Twitter', icon: 'twitter.svg', url: 'https://twitter.com' },
    { name: 'LinkedIn', icon: 'linkedin.svg', url: 'https://linkedin.com' },
    { name: 'Instagram', icon: 'instagram.svg', url: 'https://instagram.com' }
  ];

  // Quick links
  const quickLinks = [
    { name: 'Home', url: '/' },
    { name: 'About us', url: '/aboutus' },
    { name: 'Contact', url: '/contact' }
  ];

  // Services links
  const serviceLinks = [
    { name: 'Property For Sale', url: '/for-sale' },
    { name: 'Property For Rent', url: '/for-rent' },
  ];

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-content">
            {/* Company Info */}
            <div className="footer-section company-info">
              <div className="footer-logo">
                <img src="/images/logo.png" alt="Gladious Logo" />
                {/* <h3>Gladious</h3> */}
              </div>
              <p>
                Transforming businesses with innovative technology solutions that drive growth and success in the digital age.
              </p>
              <div className="social-links">
                {socialLinks.map((social, index) => (
                  <a href={social.url} key={index} className="social-link" aria-label={social.name} >
                    <img src={`/images/social/${social.icon}`} alt={social.name} />
                  </a>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-section quick-links">
              <h4>Quick Links</h4>
              <ul>
                {quickLinks.map((link, index) => (
                  <li key={index}>
                    <a href={link.url}>{link.name}</a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services */}
            <div className="footer-section services-links">
              <h4>Our Services</h4>
              <ul>
                {serviceLinks.map((link, index) => (
                  <li key={index}>
                    <a href={link.url}>{link.name}</a>
                  </li>
                ))}
              </ul>
            </div>

{/* Contact Info */}
<div className="footer-section footer-contact-info">
  <h4>Contact Us</h4>
  <address>
    <div className="footer-contact-item">
      <span className="footer-icon">
<i class="ri-map-pin-line"></i>      </span>
      <span>Royal Heights Main Boulevard Royal Orchard Multan</span>
    </div>
    <div className="footer-contact-item">
      <span className="footer-icon">
<i class="ri-phone-fill"></i>      </span>
      <span>0328-6506281, 0328-6506282</span>
    </div>
    <div className="footer-contact-item">
      <span className="footer-icon">
<i class="ri-mail-fill"></i>      </span>
      <span>gladiouscontrction@gmail.com</span>
    </div>
  </address>
  </div>
  </div>
  </div>
  </div>


      <div className="footer-bottom">
        <div className="container">
          <div className="copyright">
            <p>&copy; {currentYear} Gladious. All rights reserved.</p>
          </div>
          <div className="footer-legal">
            <a href="/privacy-policy">Privacy Policy</a>
            <a href="/terms-of-service">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;